import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './edit_category.less'
import EditForm from '../edit_form'
import DropDown from 'components/common/dropdown'
import { HeadingText } from '@paypalcorp/pp-react'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import _get from 'lodash/get'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_category')

class EditCategory extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    categoryList: PropTypes.array.isRequired,
    campaignType: PropTypes.string,
  }

  render() {
    const {
      fields: { category },
      campaignType,
    } = this.props

    return (
      <EditForm {...this.props}>
        {campaignType === CROWD_FUNDING ? (
          <HeadingText size="md" styleName="title_cf">
            {i18n('title_cf')}
          </HeadingText>
        ) : (
          <div styleName="title" role="heading" aria-level="1">
            {i18n('title')}
          </div>
        )}

        <DropDown
          label={_get(i18n('category'), 'props.children', i18n('category'))}
          formField={category}
        >
          {this.props.categoryList.map(categoryOption => {
            return (
              <option
                key={categoryOption.key}
                value={categoryOption.value}
                styleName="fs-option"
              >
                {categoryOption.label}
              </option>
            )
          })}
        </DropDown>
        <button
          data-nemo="save"
          data-pa-click="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditCategory, styles)
